import React from 'react'
import './navigation.css'

import avatar from '../../images/avatar/dbz-avatar.jpg'

class Navigation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      hasScrolled: false,
      hasBlurred: false,
      lang: 'zh',
    }
  }

  componentDidMount() {
    this.updateScrollState()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    document.addEventListener('scroll', this.handleScroll, true)
    window.addEventListener('focus', this.handleFocus)
    window.addEventListener('blur', this.handleBlur)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('scroll', this.handleScroll, true)
    window.removeEventListener('focus', this.handleFocus)
    window.removeEventListener('blur', this.handleBlur)
    if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame)
  }

  handleScroll = (event) => {
    this.scrollTarget = event && event.target
    if (this.scrollFrame) return
    this.scrollFrame = window.requestAnimationFrame(() => {
      this.scrollFrame = null
      this.updateScrollState(this.scrollTarget)
    })
  }

  updateScrollState = (eventTarget) => {
    const scrollingElement =
      document.scrollingElement || document.documentElement
    const scrollTop = Math.max(
      window.pageYOffset || 0,
      scrollingElement ? scrollingElement.scrollTop : 0,
      document.body ? document.body.scrollTop : 0,
      eventTarget && typeof eventTarget.scrollTop === 'number'
        ? eventTarget.scrollTop
        : 0
    )
    const hasScrolled = scrollTop > 50

    if (hasScrolled !== this.state.hasScrolled) {
      this.setState({ hasScrolled })
    }
  }

  handleFocus = () => {
    this.setState({ hasBlurred: false })
  }

  handleBlur = () => {
    this.setState({ hasBlurred: true })
  }

  handleBtnClick = (event) => {
    // console.log("click...")
    // if(this.state.lang=="zh"){
    //   this.setState({ lang: "en" })
    // } else {
    //   this.setState({ lang: "zh" })
    // }
    // console.log(this.state.lang)
  }

  render() {
    const logo = this.props.logo || avatar
    const logoAlt = this.props.logoAlt || ''
    const logoClassName = [
      this.state.hasBlurred ? 'blur' : '',
      this.props.logoClassName || '',
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <div
        id="Navigation"
        className={
          this.state.hasScrolled
            ? 'Navigation NavigationScrolled'
            : 'Navigation'
        }
      >
        <div className="NavigationGroup">
          <a href="/#">
            <img
              className={logoClassName}
              src={logo}
              decoding="async"
              fetchpriority="low"
              alt={logoAlt}
            />
          </a>
          <ul>
            <li>
              <a href="/#life-trace" title="人生是个不断贴标签的过程">
                {this.state.lang == 'zh' ? '人生轨迹' : 'Experience'}
              </a>
            </li>
            <li>
              <a href="/#blog" title="未来你会遇到许多有趣的人和事">
                济济一堂
              </a>
            </li>
            <li>
              <a href="/#better-live" title="生活其实很简单生出来活下去">
                好好生活
              </a>
            </li>
            <li>
              <a href="/#make-dreams" title="二十二点零六 · 杭州足迹">
                认真造梦
              </a>
            </li>
          </ul>
          {/* <button onClick={this.handleBtnClick}><Link to="#for-the-time" title="时间比我能告诉你的更多">给时间</Link></button> */}
          <a
            className="ResearchLink"
            href="/research/"
            target="_blank"
            rel="noopener noreferrer"
            title="Homepage for research in English."
            aria-label="Open the Research homepage in a new tab"
          >
            Research(EN)
          </a>
        </div>
      </div>
    )
  }
}

export default Navigation
